import React, { useState } from 'react';
import { withBillingWriteAccess } from 'contexts/adminAccess';
import { useDataProvider, useRefresh, useNotify } from 'react-admin';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { UserDetails } from '../types';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.palette.secondary.contrastText,
  },
}));

interface Props {
  achRiskTier: number;
  userId: UserDetails;
}

const ReleaseAchHoldButton = ({ achRiskTier, userId }: Props) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [loading, setLoading] = useState<boolean>(false);

  if (achRiskTier !== -1) {
    return null;
  }

  const handleReleaseTier = async () => {
    try {
      setLoading(true);

      const response = await dataProvider.post('releaseTierFromHold', { userId });

      refresh();

      return response;
    } catch (error: any) {
      notify(
        typeof error === 'string' ? error : error.message || 'ra.notification.http_error',
        'warning'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleReleaseTier}
      disabled={loading}
      className={classes.button}>
      Release ACH hold
    </Button>
  );
};

export default withBillingWriteAccess(ReleaseAchHoldButton);
